import { render } from "./ClientCallChatTab.vue?vue&type=template&id=086767a8"
import script from "./ClientCallChatTab.vue?vue&type=script&lang=js"
export * from "./ClientCallChatTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__